// extracted by mini-css-extract-plugin
export var editButton = "_kd-0";